import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './container/Header';
import Sidebar from './container/Sidebar';


const Layout: React.FC = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const sidebarToggleState = () => {
    setIsSidebarVisible(!isSidebarVisible)
  }

  return (
    <div className='layout flex flex-col md:items-end'>
      <Header sidebarToggleState={sidebarToggleState} sidebarState={isSidebarVisible} />
      <div className="content relative mx-5 mb-5 h-fit md:ml-0 md:w-md-right-fr-width lg:w-lg-right-fr-width xl:w-xl-right-fr-width 2xl:w-2xl-right-fr-width">
        <Sidebar sidebarToggleState={sidebarToggleState} sidebarState={isSidebarVisible}/>
        <div className='md:p-5'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;